"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Checkbox, NumberDisplay, TableCell, TableRow } from "@opensea/ui-kit";
import { useShallow } from "zustand/react/shallow";
import { CurrencyLink } from "@/components/currencies/CurrencyLink";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { CurrencyStatsTableRowCollection } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowCollection";
import { CurrencyStatsTableRowOneDayPriceChange } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowOneDayPriceChange";
import { CurrencyStatsTableRowPrice } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowPrice";
import { CurrencyStatsTableRowSevenDayPriceChange } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowSevenDayPriceChange";
import { CurrencyStatsTableRowSkeleton } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowSkeleton";
import { CurrencyStatsTableRowVolume } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowVolume";
import { CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES } from "@/components/stats/CurrencyStatsTable/constants";
import { CurrencyStatsTableRowSparkLineChart } from "../CurrencyStatsTable/CurrencyStatsTableRowSparkLineChart";
import { ProfileCurrencyStatsTableRowLegacyFragment } from "./ProfileCurrencyStatsTableRow.legacy.fragment";
import { useProfileTokensSelectionStore } from "./ProfileTokensSelectionProvider";
export function ProfileCurrencyStatsTableRowLegacy(t0) {
  const $ = _c(47);
  const {
    currencyBalance: currencyBalanceKey
  } = t0;
  const isOwnProfileAddress = useIsOwnProfileAddress();
  const [selectedTokensMap, selectToken] = useProfileTokensSelectionStore(useShallow(_temp));
  if (!currencyBalanceKey) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CurrencyStatsTableRowSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let currency;
  let currencyBalance;
  let t1;
  if ($[1] !== currencyBalanceKey || $[2] !== selectedTokensMap) {
    currencyBalance = readFragment(ProfileCurrencyStatsTableRowLegacyFragment, currencyBalanceKey);
    currency = currencyBalance.currency;
    t1 = selectedTokensMap.has(currency.id);
    $[1] = currencyBalanceKey;
    $[2] = selectedTokensMap;
    $[3] = currency;
    $[4] = currencyBalance;
    $[5] = t1;
  } else {
    currency = $[3];
    currencyBalance = $[4];
    t1 = $[5];
  }
  const isSelected = t1;
  let t2;
  if ($[6] !== currency.id || $[7] !== selectToken) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      selectToken(currency.id);
    };
    $[6] = currency.id;
    $[7] = selectToken;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleCheckboxClick = t2;
  let t3;
  if ($[9] !== currency.contractAddress || $[10] !== currency.symbol || $[11] !== handleCheckboxClick || $[12] !== isOwnProfileAddress || $[13] !== isSelected) {
    t3 = isOwnProfileAddress ? <TableCell className="w-6"><Checkbox aria-label={`${isSelected ? "Deselect" : "Select"} ${currency.symbol || currency.contractAddress} token`} checked={isSelected} onClick={handleCheckboxClick} /></TableCell> : null;
    $[9] = currency.contractAddress;
    $[10] = currency.symbol;
    $[11] = handleCheckboxClick;
    $[12] = isOwnProfileAddress;
    $[13] = isSelected;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = isOwnProfileAddress ? 24 : 0;
  let t5;
  if ($[15] !== currency) {
    t5 = <CurrencyStatsTableRowCollection currency={currency} />;
    $[15] = currency;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== currency || $[18] !== t5) {
    t6 = <CurrencyLink currency={currency} variant="unstyled">{t5}</CurrencyLink>;
    $[17] = currency;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = <TableCell className={`${CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.currency} !pl-0`} stickyLeft={t4}>{t6}</TableCell>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== currencyBalance.usdValue) {
    t8 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><NumberDisplay display="usd" value={currencyBalance.usdValue} /></TableCell>;
    $[23] = currencyBalance.usdValue;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== currencyBalance.quantity) {
    t9 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><NumberDisplay display="standard" value={currencyBalance.quantity} /></TableCell>;
    $[25] = currencyBalance.quantity;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== currency) {
    t10 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><CurrencyStatsTableRowPrice currency={currency} /></TableCell>;
    $[27] = currency;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== currency) {
    t11 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><CurrencyStatsTableRowOneDayPriceChange currency={currency} /></TableCell>;
    $[29] = currency;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== currency) {
    t12 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><CurrencyStatsTableRowSevenDayPriceChange currency={currency} /></TableCell>;
    $[31] = currency;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== currency) {
    t13 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.stat}><CurrencyStatsTableRowVolume currency={currency} /></TableCell>;
    $[33] = currency;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== currency) {
    t14 = <TableCell className={CURRENCY_STATS_TABLE_COLUMN_CLASSNAMES.lastOneDay}><CurrencyStatsTableRowSparkLineChart currency={currency} /></TableCell>;
    $[35] = currency;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t3 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t15 = <TableRow interactive={true}>{t3}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</TableRow>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t3;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
}
function _temp(v) {
  return [v.selectedTokensMap, v.selectToken];
}